/** @jsx jsx */
import type { ReactNode } from 'react';
import { jsx } from '@balance-web/core';
import type { WithDataAttributeProp } from '@balance-web/core';
import type { InlineProps } from '@balance-web/inline';
import { Inline } from '@balance-web/inline';
import { useTheme } from '@balance-web/theme';

export type FooterProps = WithDataAttributeProp<
  { children: ReactNode } & Pick<InlineProps, 'gap'>
>;

export const Footer = ({ children, gap, data }: FooterProps) => {
  const { borderWidth, palette } = useTheme();
  return (
    <Inline
      alignY="center"
      css={{
        borderTop: `${borderWidth.standard} solid ${palette.global.border}`,
      }}
      data={data}
      gap={gap}
      padding="large"
    >
      {children}
    </Inline>
  );
};
